module.exports = __webpack_public_path__ + "img/ee7955f.jpg";